import BaseService from "./BaseService";
import UserModel from "../models/UserModel";
import AdminModel from "../models/AdminModel";
import FileModel from "@/models/FileModel";
import RelationshipFileModel from "../models/RelationshipFileModel";

import GroupModel from "../models/GroupModel";
import GroupUserModel from "../models/GroupUserModel";

import PolicyModel from "../models/PolicyModel";

import NotificationsModel from "../models/NotificationsModel";
import CompanyModel from "../models/CompanyModel";
import AreaModel from "../models/AreaModel";
import RoleModel from "../models/RoleModel";
import DepartmentModel from "../models/DepartmentModel";
import DashboardModel from "../models/DashboardModel";
import CriteriaModel from "../models/CriteriaModel";
import CategoryModel from "../models/CategoryModel";
import PackageModel from "../models/PackageModel";
import WorkModel from "../models/WorkModel";
import HistoryPaymentModel from "../models/HistoryPaymentModel";
import CategoryDangerModel from "../models/CategoryDangerModel";
import EvaluationFormModel from "../models/EvaluationFormModel";
import ProjectModel from "../models/ProjectModel";
import ControlMeasuresModel from "../models/ControlMeasuresModel";
import EvaluationFormDangerModel from "../models/EvaluationFormDangerModel";
import SituationModel from "../models/SituationModel";
import HistoryEvaluationModel from "../models/HistoryEvaluationModel";
import HistoryControlMeasuresModel from "../models/HistoryControlMeasuresModel";
import ContractorModel from "../models/ContractorModel";
import FactoryModel from "../models/FactoryModel";
import ZoneModel from "../models/ZoneModel";
import SuppliesEquipmentModel from "../models/SuppliesEquipmentModel";
import SraModel from "../models/SraModel";
import CourseModel from "../models/CourseModel";
import AtwModel from "../models/AtwModel";
import SampleLicenseModel from "../models/SampleLicenseModel";
import DailyAtwModel from "../models/DailyAtwModel";
import PositionModel from "../models/PositionModel";
import InstructVideoModel from "../models/InstructVideoModel";
import ContractorUserModel from "../models/ContractorUserModel";
import ContractorUserViolationModel from "../models/ContractorUserViolationModel";
import UserWarningModel from "../models/UserWarningModel";
import SuppliesEquipmentWarningModel from "../models/SuppliesEquipmentWarningModel";
import CompanyGroupModel from "../models/CompanyGroupModel";
import ListViolationModel from "../models/ListViolationModel";

export default {
  services: {
    view_admin: {
      model: new AdminModel(),
      service: new BaseService(new AdminModel()),
    },
    group: {
      model: new GroupModel(),
      service: new BaseService(new GroupModel()),
    },
    group_user: {
      model: new GroupUserModel(),
      service: new BaseService(new GroupUserModel()),
    },
    users: {
      model: new UserModel(),
      service: new BaseService(new UserModel()),
    },
    file: {
      model: new FileModel(),
      service: new BaseService(new FileModel()),
    },
    relationship_file: {
      model: new RelationshipFileModel(),
      service: new BaseService(new RelationshipFileModel()),
    },

    notification: {
      service: new BaseService(new NotificationsModel()),
      model: new NotificationsModel(),
      rels: [],
    },
    policy: {
      service: new BaseService(new PolicyModel()),
      model: new PolicyModel(),
    },
    company: {
      service: new BaseService(new CompanyModel()),
      model: new CompanyModel(),
    },
    area: {
      service: new BaseService(new AreaModel()),
      model: new AreaModel(),
    },
    department: {
      service: new BaseService(new DepartmentModel()),
      model: new DepartmentModel(),
    },
    role: {
      service: new BaseService(new RoleModel()),
      model: new RoleModel(),
    },

    dashboard: {
      service: new BaseService(new DashboardModel()),
      model: new DashboardModel()
    },
    criteria: {
      model: new CriteriaModel(),
      service: new BaseService(new CriteriaModel()),
    },
    category: {
      model: new CategoryModel(),
      service: new BaseService(new CategoryModel()),
    },
    packages: {
      model: new PackageModel(),
      service: new BaseService(new PackageModel()),
    },
    work: {
      model: new WorkModel(),
      service: new BaseService(new WorkModel()),
    },
    history_payment: {
      model: new HistoryPaymentModel(),
      service: new BaseService(new HistoryPaymentModel())
    },
    category_danger: {
      model: new CategoryDangerModel(),
      service: new BaseService(new CategoryDangerModel())
    },
    evaluation_form: {
      model: new EvaluationFormModel(),
      service: new BaseService(new EvaluationFormModel())
    },
    project: {
      model: new ProjectModel(),
      service: new BaseService(new ProjectModel())
    },
    control_measures: {
      model: new ControlMeasuresModel(),
      service: new BaseService(new ControlMeasuresModel())
    },
    evaluation_form_danger: {
      model: new EvaluationFormDangerModel(),
      service: new BaseService(new EvaluationFormDangerModel())
    },
    situation: {
      model: new SituationModel(),
      service: new BaseService(new SituationModel())
    },
    history_evaluation: {
      model: new HistoryEvaluationModel(),
      service: new BaseService(new HistoryEvaluationModel())
    },
    history_control_measures: {
      model: new HistoryControlMeasuresModel(),
      service: new BaseService(new HistoryControlMeasuresModel())
    },
    contractor: {
      model: new ContractorModel(),
      service: new BaseService(new ContractorModel())
    },
    factory: {
      model: new FactoryModel(),
      service: new BaseService(new FactoryModel())
    },
    zone: {
      model: new ZoneModel(),
      service: new BaseService(new ZoneModel())
    },
    supplies_equipment: {
      model: new SuppliesEquipmentModel(),
      service: new BaseService(new SuppliesEquipmentModel())
    },
    sra: {
      model: new SraModel(),
      service: new BaseService(new SraModel())
    },
    course: {
      model: new CourseModel(),
      service: new BaseService(new CourseModel())
    },
    atw: {
      model: new AtwModel(),
      service: new BaseService(new AtwModel())
    },
    sample_license: {
      model: new SampleLicenseModel(),
      service: new BaseService(new SampleLicenseModel())
    },
    daily_atw: {
      model: new DailyAtwModel(),
      service: new BaseService(new DailyAtwModel())
    },
    position: {
      model: new PositionModel(),
      service: new BaseService(new PositionModel())
    },
    instruct_video: {
      model: new InstructVideoModel(),
      service: new BaseService(new InstructVideoModel())
    },
    contractor_user: {
      model: new ContractorUserModel(),
      service: new BaseService(new ContractorUserModel())
    },
    contractor_user_violation: {
      model: new ContractorUserViolationModel(),
      service: new BaseService(new ContractorUserViolationModel())
    },
    user_warning: {
      model: new UserWarningModel(),
      service: new BaseService(new UserWarningModel())
    },
    supplies_equipment_warning: {
      model: new SuppliesEquipmentWarningModel(),
      service: new BaseService(new SuppliesEquipmentWarningModel())
    },
    company_group: {
      model: new CompanyGroupModel(),
      service: new BaseService(new CompanyGroupModel())
    },
    list_violation: {
      model: new ListViolationModel(),
      service: new BaseService(new ListViolationModel())
    },
  },
  getModel(modelName) {
    return this.services[modelName].model;
  },
  getListFreightCustomer(modelName, params) {
    return this.services[modelName].service.getListQueryFreightCustomer(params);
  },
  getList(modelName, params) {
    return this.services[modelName].service.getListQuery(params);
  },
  countDataFreightCustomer(modelName) {
    return this.services[modelName].service.countDataQueryFreightCustomer();
  },
  countData(modelName) {
    return this.services[modelName].service.countDataQuery();
  },
  updateData(modelName) {
    return this.services[modelName].service.updateDataQuery();
  },
  insertData(modelName) {
    return this.services[modelName].service.insertDataQuery();
  },
  deleteData(modelName) {
    return this.services[modelName].service.deleteDataQuery();
  },
  getByMyId(modelName, params) {
    return this.services[modelName].service.getByMyIdQuery(params);
  },
};
